"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.075 7.079c-2.531 0-4.575 2.104-4.575 4.69 0 2.585 2.044 4.69 4.575 4.69s4.575-2.104 4.575-4.69-2.044-4.69-4.575-4.69m0 .382c2.311 0 4.193 1.925 4.193 4.308s-1.882 4.308-4.193 4.308-4.193-1.925-4.193-4.308 1.882-4.308 4.193-4.308",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.056 6.478c-3.486 0-6.944 1.574-10.364 4.666v.001l-.527.482-.158.146.158.146.526.482h.001c3.42 3.093 6.87 4.667 10.364 4.667s6.952-1.565 10.372-4.666V12.4l.527-.482.16-.146-.16-.146-.526-.482-.001-.001c-3.42-3.101-6.887-4.666-10.372-4.666m0 .395c3.148 0 6.313 1.323 9.474 4.008l.633.556.366.336-.367.337c-3.371 3.058-6.74 4.563-10.106 4.563-3.157 0-6.306-1.331-9.466-4.01l-.632-.554-.367-.336.367-.336c3.372-3.05 6.74-4.564 10.098-4.564",
    clipRule: "evenodd"
  })]
}), 'Eyes');
//# sourceMappingURL=index.js.map